import {
    ExportAnalyticsCsvParams,
    GetFoldersForAnalyticsParams,
    GetHubAnalytics,
    GetHubsAnalytics,
    GetOneTrackAnalytics,
    GetTrackAnalytics,
} from "../types/requestInputs";
import {
    GetFoldersForAnalyticsResponse,
    HubAnalyticsResponse,
    HubsAnalyticsResponse,
    TrackAnalyticsResponse,
    TracksAnalyticsResponse,
} from "../types/requestsOutputs";
import { fetchAPI } from "./utils";

export const getOneTrackAnalytics = async ({
    token,
    trackId,
    startDate,
    endDate,
}: GetOneTrackAnalytics): Promise<TrackAnalyticsResponse> => {
    return fetchAPI<TrackAnalyticsResponse>("/get-analytics-one-track", "POST", { trackId, startDate, endDate }, token);
};

export const getHubAnalytics = async ({
    token,
    folderId,
    startDate,
    endDate,
}: GetHubAnalytics): Promise<HubAnalyticsResponse> => {
    return fetchAPI<HubAnalyticsResponse>("/get-analytics-hub", "POST", { folderId, startDate, endDate }, token);
};

export const getTrackAnalytics = async ({
    token,
    trackIds,
    startDate,
    endDate,
}: GetTrackAnalytics): Promise<TracksAnalyticsResponse> => {
    return fetchAPI<TracksAnalyticsResponse>("/get-analytics-tracks", "POST", { trackIds, startDate, endDate }, token);
};

export const getHubsAnalytics = async ({
    token,
    folderIds,
    startDate,
    endDate,
}: GetHubsAnalytics): Promise<HubsAnalyticsResponse> => {
    return fetchAPI<HubsAnalyticsResponse>("/get-analytics-hubs", "POST", { folderIds, startDate, endDate }, token);
};

export const getFoldersForAnalytics = async ({
    token,
}: GetFoldersForAnalyticsParams): Promise<GetFoldersForAnalyticsResponse> => {
    return fetchAPI<GetFoldersForAnalyticsResponse>("/get-folders-for-analytics", "POST", {}, token);
};

export const exportAnalyticsCsv = async ({
    token,
    tab,
    ids,
    startDate,
    endDate,
}: ExportAnalyticsCsvParams): Promise<void> => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    if (!baseUrl) {
        throw new Error("REACT_APP_API_BASE_URL environment variable is not defined");
    }

    const response = await fetch(`${baseUrl}/export-analytics-csv`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ tab, ids, startDate, endDate }),
    });

    if (!response.ok) {
        throw new Error(`Export failed with status ${response.status}`);
    }

    const csvContent = await response.text();
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    const contentDisposition = response.headers.get("Content-Disposition");
    let filename = `analytics-${tab}.csv`;
    if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
        if (filenameMatch) {
            filename = filenameMatch[1];
        }
    }

    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};
